import { PAID_NO_SHOW_POLICY } from './appointment-transitions';
import { FOLLOW_UP_ENGINE, FOLLOW_UP_VALID_DAYS_DEFAULT, FOLLOW_UP_VALID_DAYS_MAX, FOLLOW_UP_VALID_DAYS_MIN, } from './follow-up-entitlement';
import { DAY_CLOSES_AT_MAX_HOUR } from './clinic-day';
export const SCREENING_BEFORE_READY = ['off', 'optional', 'required'];
export const QUEUE_ORDER = ['token', 'slot_then_arrival'];
export const OPD_SETTING_DEFAULTS = Object.freeze({
    freeFollowUpDays: 0,
    paidNoShowPolicy: 'refund_due',
    requireCosignForMedicalOfficer: false,
    followUpEngine: 'legacy',
    followUpValidDays: FOLLOW_UP_VALID_DAYS_DEFAULT,
    walkInWithoutSession: false,
    screeningBeforeReady: 'off',
    queueOrder: 'token',
    portalMaxUpcomingPerPatient: 3,
    quoteValidDays: 0,
    consultationChargeAt: 'arrival',
    payBeforeConsultation: 'block',
    tokenAfterPayment: false,
    dayClosesAt: 0,
    autoNoShow: false,
    autoNoShowEnabledAt: null,
    startWithoutArrival: false,
    backEntryDays: 7,
    requirePrimaryDiagnosis: false,
});
export const NEW_TENANT_OPD_BILLING = Object.freeze({
    consultationChargeAt: 'arrival',
    payBeforeConsultation: 'block',
});
export function unpaidEmrAllowed(settings) {
    return settings.payBeforeConsultation !== 'block' || settings.consultationChargeAt === 'close';
}
export const BACK_ENTRY_DAYS_MAX = 30;
function hourOfDay(value) {
    return typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= DAY_CLOSES_AT_MAX_HOUR ? value : undefined;
}
function atMost(value, max) {
    return value !== undefined && value <= max ? value : undefined;
}
function instant(value) {
    return typeof value === 'string' && !Number.isNaN(Date.parse(value)) ? value : undefined;
}
function record(raw) {
    return raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
}
function wholeNumber(value) {
    return typeof value === 'number' && Number.isInteger(value) && value >= 0 ? value : undefined;
}
function between(value, min, max) {
    return value !== undefined && value >= min && value <= max ? value : undefined;
}
function oneOf(allowed, value) {
    return typeof value === 'string' && allowed.includes(value) ? value : undefined;
}
function flag(value) {
    return typeof value === 'boolean' ? value : undefined;
}
export function resolveOpdSettings(raw, profile = {}) {
    const settings = record(raw);
    const pick = (key, parsed) => parsed ?? profile[key] ?? OPD_SETTING_DEFAULTS[key];
    return {
        freeFollowUpDays: pick('freeFollowUpDays', wholeNumber(settings.freeFollowUpDays)),
        paidNoShowPolicy: pick('paidNoShowPolicy', oneOf(PAID_NO_SHOW_POLICY, settings.paidNoShowPolicy)),
        requireCosignForMedicalOfficer: pick('requireCosignForMedicalOfficer', flag(settings.requireCosignForMedicalOfficer)),
        followUpEngine: pick('followUpEngine', oneOf(FOLLOW_UP_ENGINE, settings.followUpEngine)),
        followUpValidDays: pick('followUpValidDays', between(wholeNumber(settings.followUpValidDays), FOLLOW_UP_VALID_DAYS_MIN, FOLLOW_UP_VALID_DAYS_MAX)),
        walkInWithoutSession: pick('walkInWithoutSession', flag(settings.walkInWithoutSession)),
        screeningBeforeReady: pick('screeningBeforeReady', oneOf(SCREENING_BEFORE_READY, settings.screeningBeforeReady)),
        queueOrder: pick('queueOrder', oneOf(QUEUE_ORDER, settings.queueOrder)),
        portalMaxUpcomingPerPatient: pick('portalMaxUpcomingPerPatient', wholeNumber(settings.portalMaxUpcomingPerPatient)),
        quoteValidDays: pick('quoteValidDays', wholeNumber(settings.quoteValidDays)),
        consultationChargeAt: OPD_SETTING_DEFAULTS.consultationChargeAt,
        payBeforeConsultation: OPD_SETTING_DEFAULTS.payBeforeConsultation,
        tokenAfterPayment: pick('tokenAfterPayment', flag(settings.tokenAfterPayment)),
        dayClosesAt: pick('dayClosesAt', hourOfDay(settings.dayClosesAt)),
        autoNoShow: pick('autoNoShow', flag(settings.autoNoShow)),
        autoNoShowEnabledAt: pick('autoNoShowEnabledAt', instant(settings.autoNoShowEnabledAt)),
        startWithoutArrival: OPD_SETTING_DEFAULTS.startWithoutArrival,
        backEntryDays: pick('backEntryDays', atMost(wholeNumber(settings.backEntryDays), BACK_ENTRY_DAYS_MAX)),
        requirePrimaryDiagnosis: pick('requirePrimaryDiagnosis', flag(settings.requirePrimaryDiagnosis)),
    };
}
//# sourceMappingURL=opd-settings.js.map